import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import { Stack } from '@mui/material'

const classes = {
  slideshowWrapper: 'slideshow-wrapper',
  slideshowContainer: 'slideshow-container',
  imageGallery: 'image-gallery',
  imageGallerySlides: 'image-gallery-slides',
  imageGalleryIcon: 'image-gallery-icon',
  imageGalleryLeftNav: 'image-gallery-left-nav',
  imageGalleryRightNav: 'image-gallery-right-nav',
  imageGalleryIndex: 'image-gallery-index',
  imageGallerySvg: 'image-gallery-svg',
  imageGalleryThumbnail: 'image-gallery-thumbnail',
  imageGalleryThumbnailInner: 'image-gallery-thumbnail-inner',
}
const Root = styled(Stack)(({ theme }) => ({
  [`&.${classes.slideshowWrapper}`]: {
    height: '100%',
  },
  [`& .${classes.slideshowContainer}`]: {
    width: '100%',
  },
  [`& .${classes.imageGallery}`]: {
    // width: '50%',
  },
  [`& .${classes.imageGallerySlides}`]: {
    width: '50vw',
    margin: '0 auto',
    borderRadius: theme.shape.borderRadius,
  },
  [`& .${classes.imageGalleryIcon}`]: {
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  [`& .${classes.imageGalleryLeftNav}`]: {
    left: '14vw',
  },
  [`& .${classes.imageGalleryRightNav}`]: {
    right: '14vw',
  },
  [`& .${classes.imageGalleryIndex}`]: {
    top: theme.spacing(2),
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)',
    padding: theme.spacing(1),
    fontSize: theme.typography.body2.fontSize,
    fontFamily: theme.typography.body2.fontFamily,
    borderRadius: theme.shape.borderRadius,
  },
  [`& .${classes.imageGallerySvg}`]: {
    width: theme.spacing(1.5),
    height: theme.spacing(3),
  },
  [`& .${classes.imageGalleryThumbnail}`]: {
    borderRadius: theme.shape.borderRadius,
    '&.active, &:focus, &:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${classes.imageGalleryThumbnailInner}`]: {
    borderRadius: theme.shape.borderRadius,
  },
}))

export default function CarDetailsCarousel({ car, pictures = [] }) {
  return (
    <Root
      className={classes.slideshowWrapper}
      direction="row"
      alignItems="center"
    >
      <div className={classes.slideshowContainer}>
        <ImageGallery
          items={pictures}
          showFullscreenButton={false}
          showPlayButton={false}
          showIndex
        />
      </div>
    </Root>
  )
}

CarDetailsCarousel.propTypes = {
  car: T.object.isRequired,
  pictures: T.array,
}
